import React, { useContext, useEffect, useState } from 'react'
import { AppSettings } from '../../config/app-settings'
import { toast } from 'react-toastify'
import { can } from '../../helpers/auth'
import { useGetServiceCategoriesQuery, useLazyGetServiceCategoriesQuery } from '../../redux/apis/servicesManagement/sMServicesCategoriesApiSlice'
import ReusableTable from '../../components/other/ReuseableTable'
import Loader from '../pages/loader'
import EditCreateServiceCategory from '../../components/services/EditCreateServiceCategory'
import DownloadAllDataButton from '../../components/other/DownloadAllDataButton'

const ServicesCategories = React.memo(() => {
  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 10
  })

  const context = useContext(AppSettings)

  const { data, isLoading, error, isFetching } = useGetServiceCategoriesQuery({
    expand: ['last_updated_by'].join(','),
    page: pagination.current,
    page_size: pagination.pageSize
  })

  const [holder, setHolder] = useState()
  const [edit, setEdit] = useState(false)
  const [create, setCreate] = useState(false)

  let columns = [
    { title: 'ID', dataIndex: 'id', key: 'id', sorter: true },
    {
      title: 'CATEGORY NAME',
      dataIndex: 'category_name',
      key: 'category_name',
      search: true
    },

    {
      title: 'CREATED AT',
      dataIndex: 'created_at',
      key: 'created_at',
      search: true
    },
    {
      title: 'UPDATED AT',
      dataIndex: 'updated_at',
      key: 'updated_at',
      search: true
    },

    {
      title: 'LAST UPDATED BY',
      dataIndex: 'last_updated_by',
      key: 'last_updated_by',
      render: (text, record) => (
        <div className=''>
          <p>
            {text.first_name} {text.last_name}
          </p>
        </div>
      )
    },

    {
      title: 'Actions',
      dataIndex: 'id',
      key: 'actions',
      render: (text, record) => (
        <div className='flex gap-2'>
          {can('change_servicecategory') && (
            <button
              className='btn btn-outline-theme'
              onClick={() => handleEdit(record)}
            >
              Edit
            </button>
          )}
        </div>
      )
    }
  ]

  const handleEdit = record => {
    setHolder(record)
    setEdit(true)
  }

  const handleTableChange = paginationInfo => {
    setPagination({
      current: paginationInfo.current,
      pageSize: paginationInfo.pageSize
    })
  }

  useEffect(() => {
    if (error?.data) {
      const errorMessages = Object.values(error.data).flat()
      errorMessages.forEach(message => {
        toast.error(message)
      })
    }
  }, [error])

  useEffect(() => {
    context.setAppHeaderNone(false)
    context.setAppSidebarNone(false)
    context.setAppContentClass('')
    context.setAppThemePanal(true)

    return () => {
      context.setAppHeaderNone(true)
      context.setAppSidebarNone(true)
      context.setAppContentClass('p-0')
      context.setAppThemePanal(false)
    }
  }, [context])

  return (
    <div className='w-full flex flex-col'>
      <Loader isLoading={isLoading || isFetching} />
      {can('add_servicecategory') && create ? (
        <EditCreateServiceCategory
          state={'create'}
          open={create}
          setOpen={setCreate}
          record={null}
        />
      ) : null}
      {can('change_servicecategory') && edit ? (
        <EditCreateServiceCategory
          state={'edit'}
          open={edit}
          setOpen={setEdit}
          record={holder}
        />
      ) : null}
      <div className='ml-auto flex gap-4'>
        <DownloadAllDataButton
          lazyQueryHook={useLazyGetServiceCategoriesQuery}
          fileName='services-category'
        />
        {can('add_servicecategory') && (
          <button
            className='btn btn-outline-theme ml-auto'
            onClick={() => setCreate(true)}
          >
            Create Service Category
          </button>
        )}
      </div>
      <div className='row'>
        <ReusableTable
          columns={columns}
          data={data?.data?.results}
          pagination={{
            current: pagination.current,
            pageSize: pagination.pageSize,
            total: data?.data?.count,
            showSizeChanger: true
          }}
          onChange={handleTableChange}
        />
      </div>
    </div>
  )
})

export default ServicesCategories
